import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const querytableColumnSingleselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],

  code: [String, Array] as PropType<string | { value: string; content: string }[]>,
})

export type QuerytableColumnSingleselectProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnSingleselectProps>>>

export default defineComponent({
  name: 'OQuerytableColumnSingleselect',
  inheritAttrs: false,
  props: querytableColumnSingleselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
